<template>
  <div>
    <comment-header
      :fathertitle="fathertitle"
      :childtitle="childtitle"
      :path="path"
    >
    </comment-header>

    <!-- 查找功能 -->
    <a-form-model
      layout="inline"
      :model="form"
      @submit="handleSubmit"
      @submit.native.prevent
    >
      <a-form-model-item label="名称/代码:">
        <a-input v-model="form.param" style="width: 380px" />
      </a-form-model-item>
      <a-form-model-item label="状态:" style="margin-left:20px">
        <a-select
          v-model="form.status"
          style="width: 380px"
          placeholder="请选择"
        >
          <a-select-option value="0" key="0">全部</a-select-option>
          <a-select-option value="1" key="1">启用</a-select-option>
          <a-select-option value="2" key="2">停用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item  style="margin-left:20px">
        <a-button type="primary" html-type="submit"> 查询 </a-button>
      </a-form-model-item>
    </a-form-model>
    <!-- /查找功能 -->
    <a-button type="primary" style="margin-top: 20px" @click="showModal">
      + 新建
    </a-button>

    <!-- 新建功能 -->
    <a-modal
      v-model="visible"
      @cancel="cancelEditModel"
      :title="title"
      :footer="null"
    >
      <a-spin :spinning="isloading">
        <a-form-model
          ref="ruleForm"
          :model="editform"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item
            ref="name"
            label="名称"
            prop="name"
            class="addform"
          >
            <a-input
              v-model="editform.name"
              @blur="
                () => {
                  $refs.name.onFieldBlur();
                }
              "
            />
          </a-form-model-item>
          <a-form-model-item
            ref="code"
            label="代码"
            prop="code"
            class="addform"
          >
            <a-input
              v-model="editform.code"
              @blur="
                () => {
                  $refs.code.onFieldBlur();
                }
              "
            />
          </a-form-model-item>
          <a-form-model-item
            ref="legalPerson"
            label="法人"
            prop="legalPerson"
            class="addform"
          >
            <a-input
              v-model="editform.legalPerson"
              @blur="
                () => {
                  $refs.legalPerson.onFieldBlur();
                }
              "
            />
          </a-form-model-item>
          <a-form-model-item
            ref="linkPhone"
            label="联系电话"
            prop="linkPhone"
            class="addform"
          >
            <a-input
              v-model="editform.linkPhone"
              @blur="
                () => {
                  $refs.linkPhone.onFieldBlur();
                }
              "
            />
          </a-form-model-item>
          <a-form-model-item label="状态" class="addform">
            <a-select v-model="editform.status" placeholder="请选择状态">
              <a-select-option :value="1">启用</a-select-option>
              <a-select-option :value="2">停用</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            :wrapper-col="{ span: 14, offset: 4 }"
            class="addform"
          >
            <a-button type="primary" @click="onedituser"> 确认 </a-button>
            <a-button style="margin-left: 40px" @click="oncanceledit">
              取消
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
    <!-- /新建功能 -->

    <!-- 列表展示 -->
    <a-table
      :columns="columns"
      :data-source="data"
      :pagination="pagination"
      :loading="isloading2"
      @change="onChangepage"
      style="margin-top: 30px"
      rowKey="id"
      ref="table"
    >
      <template slot="action" slot-scope="text, index">
        <a @click="edititem(index)">编辑</a>
        <a-divider type="vertical" />
        <a href="javascript:;" @click="delUser(index)">删除</a>
      </template>
    </a-table>
    <!-- /列表展示 -->
  </div>
</template>

<script>
import CommentHeader from "@components/header";
import * as enterpriseManagement from "@api/enterpriseManagement";
const columns = [
  {
    title: "名称",
    dataIndex: "name",
  },
  {
    title: "代码",
    dataIndex: "code",
  },
  {
    title: "法人",
    dataIndex: "legalPerson",
  },
  {
    title: "联系电话",
    dataIndex: "linkPhone",
    needTotal: true,
  },
  {
    title: "新建时间",
    dataIndex: "createTime",
    sorter: true,
  },
  {
    title: "操作",
    dataIndex: "action",
    width: "150px",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  components: {
    CommentHeader,
  },
  data() {
    return {
      pagination: {
        total: 0,
      },
      fathertitle: "系统管理",
      childtitle: "企业管理",
      path: "/train/system/user-list",
      form: {},
      visible: false,
      title: "",
      isloading: false,
      pageIndex: 1,
      pageSize: 10,
      isloading2: true,
      currentUserId: "",
      editform: {},
      queryParam: {},
      columns,
      data: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入账号",
            trigger: "change",
          },
        ],
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    handleSubmit() {
      enterpriseManagement
        .getEnterprisePageList({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          param : this.form.param,
          status: this.form.status
        })
        .then((res) => {
          this.isloading2 = false;
          this.data = res.data.list;
        });
    },
    showModal() {
      this.title = "新增";
      this.visible = true;
      this.currentUserId = "";
    },
    getlist() {
      enterpriseManagement
        .getEnterprisePageList({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.isloading2 = false;
          this.data = res.data.list;
        });
    },
    onedituser() {
      console.log(this.editform);
      const form = this.$refs.ruleForm;
      const self = this;
      form.validateField("name", (error) => {
        if (!error) {
          if (self.currentUserId != "") {
            self.isloading = true;
            new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve();
              }, 500);
            }).then((res) => {
              enterpriseManagement
                .updateEnterprise({ ...this.editform, id: this.currentUserId })
                .then((r) => {
                  self.visible = false;
                  self.isloading = false;
                  // self.confirmLoading = false
                  // 重置表单数据
                  form.resetFields();
                  // 刷新表格
                  self.getlist();
                  self.$message.info("修改成功");
                });
            });
          } else {
            // 新增
            self.isloading = true;
            new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve();
              }, 500);
            }).then((res) => {
              enterpriseManagement
                .addEnterprise({ ...self.editform })
                .then((r) => {
                  self.isloading = false;
                  self.visible = false;
                  // self.confirmLoading = false;
                  // 重置表单数据
                  form.resetFields();
                  // 刷新表格
                  self.getlist();
                  this.$message.info("新增成功");
                });
            });
          }
        } else {
          return;
        }
      });
    },
    oncanceledit() {
      this.visible = false;
      this.$refs.ruleForm.resetFields();
    },
    cancelEditModel() {
      this.visible = false;
      this.$refs.ruleForm.resetFields();
    },
    onChangepage() {},
    // 点开编辑按钮
    edititem(value) {
      this.currentUserId = value.id;
      console.log(this.currentUserId);
      this.visible = true;
      this.isloading = true;
      enterpriseManagement.getEnterprise(value.id).then((res) => {
        this.isloading = false;
        this.editform = { ...res.data };
      });
    },
    // 点开编辑按钮
    delUser(value) {
      const self = this;
      this.$confirm({
        title: `你想要删除此项吗?`,
        content: `当你点击确认按钮时, 这个对话框将会在删除成功时关闭`,
        cancelText: "取消",
        okText: "确认",
        onOk() {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 500);
          })
            .then((res) => {
              enterpriseManagement
                .removeEnterprise({ id: value.id })
                .then((r) => {
                  self.$refs.ruleForm.resetFields()
                  self.getlist()
                });
            })
            .catch(() => console.log("小猪，出错啦，休息会吧!"));
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .addform.ant-form-item {
  display: flex;
  justify-content: center;
}
</style>